<template>
  <v-container>
    <div v-html="evaluation.task"></div>
    <br />
    <div>
      <p>
        <v-file-input @click="checkConnection"
          show-size
          chips
          multiple
          :rules="rules"
          v-model="files"
          :loading="false"
          label="Додайте файл"
          accept="image/jpeg,
            image/png,
            image/jpg,
            audio/mp3,
            .doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ></v-file-input>
        <span>{{ errorMessage }}</span>
      </p>
    </div>

    <div>
      <v-btn large color="primary" @click="sendAnswer">Відповісти</v-btn>
    </div>
  </v-container>
</template>

<script>
import evaluationEventEnum from '@/enums/evaluationEventEnum';
const ERROR_MESSAGE = 'Розмір файлу має бути менше 10 MB!';
const ERROR_MESSAGE_OFFLINE = 'Немає з\'єднання з мережею, спробуйте пізніше';

export default {
  name: 'AddFileEvaluation',
  props: {
    evaluation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      files: [],
      errorMessage: '',
      rules: [
        (value) => {
          return (
            !value || !value.size || value.size < 10000000 || ERROR_MESSAGE
          );
        },
      ],
    };
  },
  watch: {
    evaluation(evaluation) {
      this.files = evaluation.answer || [];
    },
  },

  methods: {
    sendAnswer() {

      const isValid = this.files.every((file) => {
        return (
          file.size &&
          this.rules.every((rule) => {
            return typeof rule(file) !== 'string';
          })
        );
      });
      if (!isValid) {
        this.$emit('evaluateEvent', {
          type: evaluationEventEnum.SHOW_TOASTER,
          data: {
            text: ERROR_MESSAGE,
          },
        });
        return;
      }
      this.$emit('evaluateEvent', {
        type: evaluationEventEnum.SEND_ANSWER,
        data: {
          answer: this.files,
        },
      });
    },
    
    checkConnection(e){  
          
      if (!navigator.onLine) {
         e.preventDefault(); 
         this.$emit('evaluateEvent', {
          type: evaluationEventEnum.SHOW_TOASTER,
          data: {
            text: ERROR_MESSAGE_OFFLINE,
          },
        });
      }
    },
  },
};
</script>
